import { RosLibJsActionCaller, RosLibJsActionOptions } from "./roslibjs";
import { FoxgloveActionCaller, FoxgloveActionOptions } from "./foxglove";

export const ActionSources = {
  ROSLIBJS: RosLibJsActionCaller,
  FOXGLOVE: FoxgloveActionCaller,
};

type MakeActionCallerFn = {
  (type: "ROSLIBJS", options: RosLibJsActionOptions): RosLibJsActionCaller;
  (type: "FOXGLOVE", options: FoxgloveActionOptions): FoxgloveActionCaller;
};

export const makeActionCaller: MakeActionCallerFn = (type, options): any => {
  switch (type) {
    case "ROSLIBJS":
      return new RosLibJsActionCaller(options as RosLibJsActionOptions);
    case "FOXGLOVE":
      return new FoxgloveActionCaller(options as FoxgloveActionOptions);
    default:
      throw new Error(
        `Unable to make action caller because of invalid action source type ${type}. Must be one of ${Object.keys(
          ActionSources
        )}`
      );
  }
};

export { ActionCaller, ActionNotSupportedError } from "../base";
export type { ActionCallbacks, ActionHandle } from "../base";
